import numberUtils from 'app/shared/utils/numberUtils';

export interface FloorplanUnitProps {
  availabilityDate?: string;
  baths?: string;
  beds?: string;
  high?: string;
  low?: string;
  modelId?: string;
  name?: string;
  sqft?: string;
  isNewUnit?: boolean;
  createdAgo?: string;
  hasPriceDropped?: boolean;
  priceDrop?: string | number;
}

class FloorplanUnit {
  modelId: string;
  name: string;
  availabilityDate: string;
  beds: number;
  baths: number;
  sqft: number;
  low: number;
  high: number;
  priceRangeDisplay: Array<string>;
  isNewUnit: boolean;
  createdAgo: string;
  hasPriceDropped: boolean;
  priceDrop: number;

  constructor({
    availabilityDate = '',
    baths = '',
    beds = '',
    high = '',
    low = '',
    modelId = '',
    name = '',
    sqft = '',
    isNewUnit = false,
    createdAgo = '',
    hasPriceDropped = false,
    priceDrop = 0,
  }: FloorplanUnitProps = {}) {
    this.modelId = modelId;
    this.name = name;
    this.availabilityDate = availabilityDate;
    this.beds = Number(beds);
    this.baths = Number(baths);
    this.sqft = Number(sqft);
    this.low = Number(low);
    this.high = Number(high);
    this.priceRangeDisplay = [numberUtils.compact(low), numberUtils.compact(high)];
    this.isNewUnit = Boolean(isNewUnit);
    this.createdAgo = createdAgo?.toString()?.trim() || '';
    this.hasPriceDropped = Boolean(hasPriceDropped);
    this.priceDrop = Number(priceDrop);
  }
}

export default FloorplanUnit;
